// src/components/Scanners.jsx
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import SuccessIcon from "../../images/success_icon.svg";
import ErrorIcon from "../../images/error_icon.svg";
import { toast } from 'react-toastify';
import CustomToastContent from '../../components/CustomToastContent';
import { useOptionChainScreenContext } from '../OptionChainScreen/context/OptionChainContext';
import { useBuilderContext } from '../StrategyCreator/context/BuilderContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { getCookie } from '../../utils/cookieUtils';

function Scanners({ visible }) {
    const { setSelectedSymbol, setActiveTab, setSearchSymbol } = useOptionChainScreenContext();
    const { allSymbols } = useBuilderContext();
    const { theme } = useTheme();

    const iframeRef = useRef(null);
    const hasInitialized = useRef(false);
    const hasInitialized2 = useRef(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);

    const passedSymbol = useMemo(() => {
        const query = new URLSearchParams(location.search);
        return {
            scrip: query.get('scrip'),
            exchange: query.get('exchange'),
            code: query.get('code')
        };
    }, [location.search]);

    const iframeSrc = useMemo(() => {
        const accessToken = getCookie('access_token');
        const webSocketToken = getCookie('ws_token');
        const userId = getCookie('client_id');
        const theme1 = localStorage.getItem('theme');
        const broker = getCookie('broker');
        const baseUrl = 'http://localhost:5000/';

        const query = new URLSearchParams({
            accessToken,
            webSocketToken,
            userId,
            theme1,
            broker
        });
        return `${baseUrl}?${query.toString()}`;
    }, [passedSymbol]);

    useEffect(() => {
        if (hasInitialized.current) {
            iframeRef.current?.contentWindow?.postMessage(
                { type: 'someEventFromReact', payload: 'toggleTheme' },
                '*'
            );
        } else {
            hasInitialized.current = true;
        }
    }, [theme]);
    useEffect(() => {
        // console.log("passed symbol")
        if (hasInitialized2.current) {
            if (passedSymbol) {

                iframeRef.current?.contentWindow?.postMessage(
                    { type: 'scannerNavigation', payload: passedSymbol },
                    '*'
                );
            }
        } else {
            hasInitialized2.current = true;
        }
    }, [passedSymbol]);

    useEffect(() => {
        const handleMessage = (event) => {
            const { type, message } = event.data || {};

            if (type === 'success') {
                toast.success(
                    <CustomToastContent heading={type} message={message} />,
                    { className: 'custom-success-toast', icon: <img src={SuccessIcon} alt="Success Icon" /> }
                );
            }

            if (type === 'error') {
                toast.error(
                    <CustomToastContent heading={type} message={message} />,
                    { className: 'custom-error-toast', icon: <img src={ErrorIcon} alt="Error Icon" /> }
                );
            }

            if (type === 'optionChain' && message) {
                const matchedSymbol = allSymbols?.find(symbol => symbol.scrip === message);
                if (matchedSymbol) {
                    setSelectedSymbol(matchedSymbol);
                    setSearchSymbol(matchedSymbol);
                    setActiveTab('Search');
                    window.history.pushState({}, '', '/optionchain');
                    window.dispatchEvent(new PopStateEvent('popstate'));
                }
            }

            if (event.data?.command === 'executed') {
                // console.log('Received command from Flutter');
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [allSymbols]);

    return (
        <div className="fixed inset-0 z-50" style={{ display: visible ? 'block' : 'none' }}>
            {loading && (
                <div className="w-full h-full mt-16 flex items-center justify-center bg-white dark:bg-gray-900">
                    <div className="w-11/12 h-full animate-pulse bg-gray-200 dark:bg-gray-700 rounded-md" />
                </div>
            )}
            <iframe
                ref={iframeRef}
                src={iframeSrc}
                title="Scanners"
                className={`w-full h-full mt-16 border-0 ${loading ? 'hidden' : 'block'}`}
                onLoad={() => setLoading(false)}
            />
        </div>
    );
}

export default Scanners;


